import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import { useNavigate } from 'react-router-dom';
import {
  FaCertificate,
  FaUserTie,
  FaChartBar,
  FaFileUpload,
  FaCheckCircle,
  FaBan,
  FaWallet,
  FaArrowRight,
  FaArrowLeft,
} from 'react-icons/fa';
import { retrieveMessagesFromHcs } from '../api/auditAPI';
import { getAllVCs } from '../api/ssiAPI';
import { getMe } from '../api/loginAPI';
import { getProductsByUserId } from '../api/productApi';
import { getWalletMappingsByIssuer } from '../api/wallet-mappingAPI';

function Dashboard() {
  const navigate = useNavigate();
  const [auditLogs, setAuditLogs] = useState([]);
  const [allCertificates, setAllCertificates] = useState([]);
  const [allWallets, setAllWallets] = useState([]);
  const [walletEnabled, setWalletEnabled] = useState(false);
  const [certificateEnabled, setCertificateEnabled] = useState(false);
   const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
  

  const [user, setUser] = useState(null);
    
      useEffect(() => {
        async function fetchUser() {
          const userData = await getMe();
          console.log('UserData', userData)
          setUser(userData);
        }
        fetchUser();
      }, []);

  useEffect(() => {
    async function fetchProducts() {
      try {
        const user = await getMe();
        const products = await getProductsByUserId(user.Id);
        setWalletEnabled(products.some(p => p.productName === 'EarthID Wallet'));
        setCertificateEnabled(products.some(p => p.productName === 'Digital Certificate'));
      } catch (err) {
        console.error('❌ Error fetching user/products', err);
      }
    }
    fetchProducts();
  }, []);

  useEffect(() => {
    async function fetchVCs() {
      try {
        const data = await getAllVCs(user.Id);
        if (Array.isArray(data?.response)) {
          setAllCertificates(data.response);
        } else {
          setAllCertificates([]);
        }
      } catch (err) {
        console.error('❌ Failed to fetch VCs:', err);
      }
    }

    if (certificateEnabled) {
      fetchVCs();
    }
  }, [certificateEnabled]);

    useEffect(() => {
    if (user) {
      getWalletMappingsByIssuer(user.Id).then(setAllWallets);
      console.log('these are the wallets',allWallets)
    }
  }, [user]);

  useEffect(() => {
    async function fetchAuditLogs() {
      try {
        const response = await retrieveMessagesFromHcs();
        setAuditLogs((response?.messages || []).reverse());
      } catch (err) {
        console.error('❌ Failed to fetch audit logs:', err);
      }
    }

    fetchAuditLogs();
  }, []);

  const totalIssued = allCertificates.length;
  const activeCount = allCertificates.length;
  const revokedCount = 0;

  const walletTotalIssued = allWallets.length;
const walletActiveCount = allWallets.filter(w => w.status !== 'revoked').length;
const walletRevokedCount = allWallets.filter(w => w.status === 'revoked').length;

  const certificateCards = [
    {
      title: 'Issue Certificate',
      description: 'Manually or in bulk',
      icon: <FaUserTie />,
      path: '/issue',
    },
    {
      title: 'Issued Certificates',
      description: 'View, update, or revoke',
      icon: <FaCertificate />,
      path: '/certificates',
    }
  ];

  const walletCards = [
    {
      title: 'Issue Wallet',
      description: 'Generate and send',
      icon: <FaWallet />,
      path: '/issuewallet',
    },
    {
      title: 'Issued Wallets',
      description: 'Manage all wallets',
      icon: <FaWallet />,
      path: '/wallets',
    },
  ];

  const utilityCards = [
  {
    title: 'Upload Excel',
    description: 'Mass upload tool',
    icon: <FaFileUpload />,
    path: '/upload-excel',
  },
  {
    title: 'Reports',
    description: 'Graphs and export data',
    icon: <FaChartBar />,
    path: '/reports',
  },
];

const paginatedLogs = auditLogs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(auditLogs.length / itemsPerPage);


  return (
    <div className="dashboard-page">
      <h2 className="dashboard-title">Welcome to the EarthID Admin Dashboard</h2>
      <p className="dashboard-subtitle">
        Manage certificate issuance, wallet creation, and analytics from one place.
      </p>

     {certificateEnabled && (
  <>
    <h3 className="product-section-title">Digital Certificate</h3>
    <div className="dashboard-stats">
      <div className="report-card issued">
        <FaCertificate className="card-icon" />
        <div>
          <h3>{totalIssued}</h3>
          <p>Total Issued</p>
        </div>
      </div>
      <div className="report-card active">
        <FaCheckCircle className="card-icon" />
        <div>
          <h3>{activeCount}</h3>
          <p>Active Certificates</p>
        </div>
      </div>
      <div className="report-card revoked">
        <FaBan className="card-icon" />
        <div>
          <h3>{revokedCount}</h3>
          <p>Revoked Certificates</p>
        </div>
      </div>
    </div>
  </>
)}

{walletEnabled && (
  <>
    <h3 className="product-section-title">EarthID Wallet</h3>
    <div className="dashboard-stats">
      <div className="report-card issued">
        <FaWallet className="card-icon" />
        <div>
          <h3>{walletTotalIssued}</h3>
          <p>Total Issued</p>
        </div>
      </div>
      <div className="report-card active">
        <FaCheckCircle className="card-icon" />
        <div>
          <h3>{walletActiveCount}</h3>
          <p>Active Wallets</p>
        </div>
      </div>
      <div className="report-card revoked">
        <FaBan className="card-icon" />
        <div>
          <h3>{walletRevokedCount}</h3>
          <p>Revoked Wallets</p>
        </div>
      </div>
    </div>
  </>
)}



      <div className="dashboard-grid">
        {certificateEnabled &&
          certificateCards.map((card, index) => (
            <div
              key={`cert-${index}`}
              className="dashboard-card"
              onClick={() => navigate(card.path)}
            >
              <div className="dashboard-icon">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}

        {walletEnabled &&
          walletCards.map((card, index) => (
            <div
              key={`wallet-${index}`}
              className="dashboard-card"
              onClick={() => navigate(card.path)}
            >
              <div className="dashboard-icon">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}

          {/* 🛠 Utility Section */}

<div className="dashboard-grid">
  {utilityCards.map((card, index) => (
    <div
      key={`utility-${index}`}
      className="dashboard-card"
      onClick={() => navigate(card.path)}
    >
      <div className="dashboard-icon">{card.icon}</div>
      <h3>{card.title}</h3>
      <p>{card.description}</p>
    </div>
  ))}
</div>
      </div>

      <div className="dashboard-bottom">
        <div className="recent-activity">
          <h3>Recent Activity</h3>
          <table className="table-section">
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Event</th>
                <th>Action</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {paginatedLogs.length > 0 ? (
                paginatedLogs.map((log, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{log.event || 'N/A'}</td>
                    <td>{log.message || 'N/A'}</td>
                    <td>{log.timestamp || 'N/A'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No activity found</td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="pagination-controls">
                  <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
                    <FaArrowLeft />
                  </button>
                  <span>Page {currentPage} of {totalPages}</span>
                  <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
                    <FaArrowRight />
                  </button>
                </div>
        </div>

        <div className="new-updates">
          <h3>New Updates</h3>
          <ul>
            <li>New bulk upload feature added</li>
            <li>UI enhancements for certificate preview</li>
            <li>Real-time activity tracking launched</li>
            <li>Dark mode toggle coming soon</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
